import {
	COMMON_REQ, COMMON_REQ_FAIL,
	LOAD_SESSION_SUCCESS, LOAD_SESSION_FAIL,
	REMOVE_SESSION_SUCCESS,
	SWITCH_ROLE_REQ,
	SWITCH_ROLE_SUCCESS,
	UPDATE_SESSION_USER,
	COMMON_REQ_LIVE
} from '../reducers/session';

export const loadSession = () => {
	return dispatch => {
		dispatch({
			types: [COMMON_REQ, LOAD_SESSION_SUCCESS, LOAD_SESSION_FAIL],
			promise: (client) => client.get('/auth/session', {}),
			setLang: true
		});
	}
};

export const loadSessionLive = () => {
	return dispatch => {
		dispatch({
			types: [COMMON_REQ_LIVE, LOAD_SESSION_SUCCESS, LOAD_SESSION_FAIL],
			promise: (client) => client.get('/auth/session', {}),
			setLang: true
		});
	}
};

export const removeSession = () => {
	return dispatch => {
		dispatch({
			types: [COMMON_REQ, REMOVE_SESSION_SUCCESS, COMMON_REQ_FAIL],
			promise: (client) => client.post('/auth/logout', {})
		})
	}
};

export const switchRole = (roleId) => {
	return dispatch => {
		dispatch({
			types: [SWITCH_ROLE_REQ, SWITCH_ROLE_SUCCESS, COMMON_REQ_FAIL],
			promise: (client) => client.get(`auth/switch-role/${roleId}`, {}),
			successRedirect: '/dashboard'
		});
	}
};

export const updateSessionUser = (user) => {
	return dispatch => {
		dispatch({
			type: UPDATE_SESSION_USER,
			updatedUser: user
		})
	}
};